import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { Customer, Product } from "../../Store/interfaces";
import logo2 from "./FREY_1810x337.png";
import ProductTableFP from "./ProductTableFP";

const PDFServiceschein = ({
  selectedCustomer,
  customerSign,
  techSign,
  vorname,
  nachname,
  startTime,
  endTime,
  comment,
  products,
  zielOrt,
  startOrt,
  distanz,
  fahrtZeit,
  fahrtBerechnen,
  day,
}: {
  selectedCustomer: Customer;
  customerSign: string;
  techSign: string;
  vorname: string;
  nachname: string;
  startTime: Date;
  endTime: Date;
  comment: string;
  products: Product[];
  zielOrt: string;
  startOrt: string;
  distanz: number;
  fahrtZeit: number;
  fahrtBerechnen: boolean;
  day: Date;
}) => {
  const styles = StyleSheet.create({
    page: {
      padding: 30,
      fontFamily: "Helvetica",
      fontSize: 11,
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "baseline",
      marginBottom: 20,
    },
    section: {
      marginBottom: 20,
      // flexGrow: 1,
    },
    footer: {
      position: "absolute",
      bottom: 10,
      left: 30,
      right: 30,
      flexDirection: "row",
      justifyContent: "space-between",
      fontSize: 8,
    },
    imageContainer: {
      marginBottom: "30",
      width: "35%",
      height: "75",
      justifyContent: "center",
      alignItems: "center",
    },
    image: {
      width: "100%",
      height: "100%",
      // borderColor: "#000",
      // borderWidth: 1,
    },
    logo_schmoll: {
      width: 100,
      height: 20,
    },
    logo: {
      width: 100,
      height: 19,
    },
    rectangle: {
      height: 5,
      width: 100,
      backgroundColor: "#003c78",
      marginTop: -5,
      marginRight: -30,
    },
    descriptionText: {
      justifyContent: "space-evenly",
      alignItems: "center",
      marginTop: 5,
    },
    commentSection: {
      marginBottom: 10, // Adjust margin as needed
    },
    secondHeadline: {
      marginBottom: 5,
      textDecoration: "underline",
      fontSize: 13,
      // color: '#4b4b4b'
    },
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View fixed style={styles.header}>
          <Image source={logo2} style={styles.logo} />
          {/* <Image style={styles.logo_schmoll} source={logo} /> */}
          <Text style={{ fontSize: 24 }}>Serviceschein</Text>
          <View>
            <View style={styles.rectangle} />
          </View>
        </View>

        {/* Formal Letter Head */}
        <View
          style={[
            styles.section,
            {
              justifyContent: "space-between",
              flexDirection: "row",
              padding: 0,
            },
          ]}
        >
          {/* Left section: Customer data */}
          <View style={{ flexDirection: "column" }}>
            <Text>Kunde: {selectedCustomer.Kundennummer}</Text>
            <Text>Name: {selectedCustomer.Kunde}</Text>
            <Text>Adresse: {zielOrt}</Text>
          </View>

          {/* Right section: Your data */}
          <View style={{ flexDirection: "column" }}>
            <Text>
              Techniker: {vorname} {nachname}
            </Text>
            <Text>
              Datum: {day.getDate().toString().padStart(2, "0")}.
              {(day.getUTCMonth() + 1).toString().padStart(2, "0")}.
              {day.getFullYear()}
            </Text>
            <Text>
              Arbeitszeitraum:{" "}
              {startTime.getHours().toString().padStart(2, "0")}:
              {startTime.getMinutes().toString().padStart(2, "0")} -{" "}
              {endTime.getHours().toString().padStart(2, "0")}:
              {endTime.getMinutes().toString().padStart(2, "0")}
            </Text>
          </View>
        </View>
        {fahrtBerechnen ? (
          <View style={styles.section}>
            <Text style={styles.secondHeadline}>Anfahrt</Text>
            <Text>
              {startOrt} - {zielOrt}
            </Text>
          </View>
        ) : (
          <></>
        )}

        {/* Detailed Information Field */}

        {products.length > 0 ? (
          <View style={styles.section}>
            <Text style={styles.secondHeadline}>
              Grund des Technikereinsatzes:
            </Text>
            <Text>{comment}</Text>
          </View>
        ) : (
          <View style={[styles.section, { flexGrow: 1 }]}>
            <Text style={styles.secondHeadline}>
              Grund des Technikereinsatzes:
            </Text>
            <Text>{comment}</Text>
          </View>
        )}

        {/* Table */}
        {products.length > 0 ? (
          <View style={[styles.section, { flexGrow: 1 }]}>
            <Text style={styles.secondHeadline}>
              Materialien & Dienstleistungen:
            </Text>
            <ProductTableFP products={products} />
          </View>
        ) : (
          <></>
        )}

        {/* Comment Section */}
        {/* {comment && (
            <View style={[styles.section, styles.commentSection]}>
              <Text>{comment}</Text>
            </View>
          )} */}

        {/* Space for Pictures */}
        <View
          style={[
            styles.section,
            {
              flexDirection: "row",
              justifyContent: "space-around",
            },
          ]}
        >
          <View style={styles.imageContainer}>
            <Image src={customerSign} style={styles.image} />
            <View
              style={[
                styles.rectangle,
                { backgroundColor: "black", height: 0.5, width: "100%" },
              ]}
            />
            <Text style={styles.descriptionText}>Kunde</Text>
          </View>
          <View style={styles.imageContainer}>
            <Image src={techSign} style={styles.image} />
            <View
              style={[
                styles.rectangle,
                { backgroundColor: "black", height: 0.5, width: "100%" },
              ]}
            />
            <Text style={styles.descriptionText}>Techniker</Text>
          </View>
        </View>

        {/* Footer */}
        <View fixed style={styles.footer}>
          <View style={{ flexDirection: "column" }}>
            <Text>FREY ADV GmbH</Text>
            <Text>Chausseestraße 189</Text>
            <Text>15712 Königs Wusterhausen</Text>
            <Text>Telefon: 03375 9238 0</Text>
            <Text>Telefax: 03375 9238 222</Text>
          </View>
          <View style={{ flexDirection: "column" }}>
            <Text>Geschäftführer</Text>
            <Text>Lars Wichmann</Text>
            <Text>Mariola Hein</Text>
            <Text>Marie-Theres Frey</Text>
          </View>
          <View style={{ flexDirection: "column" }}>
            <Text>Amtsgericht Düsseldorf</Text>
            <Text>HRB 43976</Text>
            <Text>USt.-Id.-Nr.:</Text>
            <Text>De 203159492</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default PDFServiceschein;
